import { render, staticRenderFns } from "./LpusRegisterContent.vue?vue&type=template&id=22717bac&scoped=true&"
import script from "./LpusRegisterContent.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpusRegisterContent.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpusRegisterContent.vue?vue&type=style&index=0&id=22717bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22717bac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22717bac')) {
      api.createRecord('22717bac', component.options)
    } else {
      api.reload('22717bac', component.options)
    }
    module.hot.accept("./LpusRegisterContent.vue?vue&type=template&id=22717bac&scoped=true&", function () {
      api.rerender('22717bac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/lpus/register/index/LpusRegisterContent/LpusRegisterContent.vue"
export default component.exports